import React from "react";
// import PropTypes from 'prop-types';

Tiles.propTypes = {};

function Tiles({ value, handleClick, isWinSquares }) {
	return (
		<button
			onClick={handleClick}
			type="button"
			className={`square ${isWinSquares ? "winning" : ""} ${
				value === "X" ? "text-green" : "text-orange"
			}`}
			style={{ fontWeight: isWinSquares ? "bold" : "normal" }}
		>
			{value}
		</button>
	);
}

export default Tiles;
